import { xhrLoad } from '../functions/xhrLoad';
import { slideDown, slideUp } from '../modules/domSlider';
import { setTotalPrice, setWithoutVatPrice } from '../functions/productChange';
import { WEDDING_SWITCHER_CLASS, METAL_ATTR, getDefaultDeliveryId } from '../functions/productChange';
import { querySelectorId, querySelectorAll, querySelector } from './querySelectors';
import { THUMB_IMAGE_CLASS, THUMB_ACTIVE_CLASS } from '../scripts/productGallery.js';
import formatParams from '../functions/formatParams';
import { RADIO_INPUT_CLASS, THICKNESS_SYMBOL, WEIGHT_SYMBOL } from '../config/main';

const WIDTH_UNI_ID = 'product-choose-width';
const SIZE_UNI_DEST_CLASS = 'width-detail';
const GENDERS_ARRAY = ['mn', 'wm'];
const GENDERS_ARRAY_MAP = {'wm': 2, 'mn': 1};
const FORM_ID = 'ProductViewForm';
const WEIGHT_UNI_DEST_CLASS = 'weight-detail';
const GENDER_UNI_DEST_CLASS = 'js-wdd';
const METAL_UNI_DEST_CLASS = 'product-metal-detail';
const THICKNESS_UNI_DEST_CLASS = 'product-thickness-detail';
const SURFACE_UNI_DEST_CLASS = 'product-surface-detail';
const GENDER_ATTR = 'data-gender';
const COLOR_ATTR = 'data-type-color';
const THICKNESS_ATTR = 'data-type-thickness';
const SURFACE_ATTR = 'data-type-surface';
const CARATS_ATTR = 'data-type-carats';
const CARATS_DEFAULT_MATERIAL_ATTR = 'data-material';
const CARATS_VALUE_ATTR = 'data-carats';
const GEM_TYPE_ATTR = 'data-type-gem_type';
const METAL_VALUE_ATTR = 'data-metal';
const INPUT_TEXT_ATTR = 'data-input-text';
const GEM_GENDER_CLASS = 'js-wdd_gem-';
const GEM_DETAIL_CLASS = 'product-gem-origin-detail';
const METAL_POSTFIX = '585/1000';
const DIAMOND_CLASS = 'js-wdd_gem-';

let getActiveGemType = function(gender) {
  return querySelector(`.${RADIO_INPUT_CLASS}[${GEM_TYPE_ATTR}][data-gender="${gender}"]:checked`);
};

let getGemType = function(gender) {
  return querySelector(`.${GEM_GENDER_CLASS}${gender} .${GEM_DETAIL_CLASS}`);
};

let getActiveColor = function(gender) {
  return querySelector(`.${RADIO_INPUT_CLASS}[${COLOR_ATTR}][data-gender="${gender}"]:checked`);
};

let getActiveThickness = function(gender) {
  return querySelector(`.${RADIO_INPUT_CLASS}[${THICKNESS_ATTR}][data-gender="${gender}"]:checked`);
};

let getActiveSurface = function(gender) {
  return querySelector(`.${RADIO_INPUT_CLASS}[${SURFACE_ATTR}][data-gender="${gender}"]:checked`);
};

let getActiveCarats = function(gender) {
  return querySelector(`.${RADIO_INPUT_CLASS}[${CARATS_ATTR}][data-gender="${gender}"]:checked`);
};

let getCarats = function(gender) {
  let element = getActiveCarats(gender);

  if (element) {
    return element.getAttribute(CARATS_VALUE_ATTR);
  }
};

let getCaratsDefaultMaterial = function(gender) {
  let element = getActiveCarats(gender);

  if (element) {
    return element.getAttribute(CARATS_DEFAULT_MATERIAL_ATTR);
  }
};

let getMetal = function(gender) {
  let input = getActiveColor(gender);

  if (input) {
    return getActiveColor(gender).getAttribute(METAL_VALUE_ATTR);
  }

  return null;
};

let checkGalleryMove = function(changedItem, input, galleryAttr) {
  if (changedItem === input && typeof changedItem.getAttribute(galleryAttr) === 'string' && window.imagesArray.length) {
    let newActive;

    newActive = querySelector(`.${THUMB_IMAGE_CLASS}[${galleryAttr}="${changedItem.getAttribute(galleryAttr)}"]`);

    if (newActive && !newActive.parentNode.classList.contains(THUMB_ACTIVE_CLASS)) {
      newActive.click();
      return true;
    }
  }

  return false;
};

let setWidth = function(gender) {
  let source = querySelectorId(`${WIDTH_UNI_ID}-${gender}`);
  let dest = querySelector(`.${gender}-${SIZE_UNI_DEST_CLASS}`);

  if (source && dest) {
    let newValue = source.options[source.options.selectedIndex].textContent;

    if (dest) {
      dest.textContent = newValue;
    }
  }
};

let setWeight = function(gender, newValue) {
  if (newValue) {
    let dest = querySelector(`.${gender}-${WEIGHT_UNI_DEST_CLASS}`);

    if (dest) {
      dest.textContent = `${newValue} ${WEIGHT_SYMBOL}`;
    }
  }
};

let setColor = function(gender) {
  let dest = querySelector(`.${GENDER_UNI_DEST_CLASS}-${gender} .${METAL_UNI_DEST_CLASS}`);
  let carats = getCarats(gender);
  let metal = getMetal(gender);

  if (dest) {
    if (carats && metal) {
      dest.textContent = window.product_metals[`${carats}_${metal}`];
    }
    else if (carats) {
      dest.textContent = window.product_metals[`${carats}_${getCaratsDefaultMaterial(gender)}`];
    }
    else {
      let input = getActiveColor(gender);

      if (input) {
        let dest = querySelector(`.${GENDER_UNI_DEST_CLASS}-${gender} .${METAL_UNI_DEST_CLASS}`);

        if (dest) {
          dest.textContent = `14 Karat ${input.getAttribute(INPUT_TEXT_ATTR)} ${METAL_POSTFIX}`;
        }
      }
    }
  }
};

let setThickness = function(gender) {
  let input = getActiveThickness(gender);

  if (input) {
    let dest = querySelector(`.${GENDER_UNI_DEST_CLASS}-${gender} .${THICKNESS_UNI_DEST_CLASS}`);

    if (dest) {
      dest.textContent = `${input.getAttribute(INPUT_TEXT_ATTR)} ${THICKNESS_SYMBOL}`;
    }
  }
};

let setSurface = function(gender) {
  let input = getActiveSurface(gender);

  if (input) {
    let dest = querySelector(`.${GENDER_UNI_DEST_CLASS}-${gender} .${SURFACE_UNI_DEST_CLASS}`);

    if (dest) {
      dest.textContent = input.getAttribute(INPUT_TEXT_ATTR);
    }
  }
};

let setDescription = function(changedItem) {
  let switchers = querySelectorAll(`.${WEDDING_SWITCHER_CLASS}`);
  let activeGenders = [];

  if (switchers.length) {
    switchers.forEach((switcher) => {
      if (switcher.checked) {
        activeGenders.push(switcher.getAttribute(GENDER_ATTR));
      }
    });

    for (let i in GENDERS_ARRAY) {
      let description = querySelector(`.js-wdd-${GENDERS_ARRAY[i]}`);
      let diamondDescription = querySelector(`.${DIAMOND_CLASS}${GENDERS_ARRAY[i]}`);

      if (activeGenders.indexOf(GENDERS_ARRAY[i]) !== -1) {
        slideDown({
          element: description
        });

        if (diamondDescription) {
          slideDown({
            element: diamondDescription
          });
        }
      }
      else {
        slideUp({
          element: description
        });

        if (diamondDescription) {
          slideUp({
            element: diamondDescription
          });
        }
      }
    }
  }

  if (window.imagesArray.length) {
    let newActive;
    let moved = false;

    if (changedItem && changedItem.classList.contains(RADIO_INPUT_CLASS)) {
      if (typeof changedItem.getAttribute(COLOR_ATTR) === 'string') {
        moved = checkGalleryMove(changedItem, getActiveColor(changedItem.getAttribute(GENDER_ATTR)), METAL_ATTR);
      }
      /* tady pripadne pridat tloustku a upravu povrchu pro zmenu galerie */
    }

    if (!moved) {
      if (activeGenders.length === 1) {
        newActive = querySelector(`.${THUMB_IMAGE_CLASS}[${GENDER_ATTR}="${GENDERS_ARRAY_MAP[activeGenders[0]]}"]`);
      }
      else {
        newActive = querySelector(`.${THUMB_IMAGE_CLASS}`);
      }

      if (newActive && !newActive.parentNode.classList.contains(THUMB_ACTIVE_CLASS)) {
        newActive.click();
      }
    }
  }
};

let setGemType = function(gender) {
  let item = getGemType(gender);
  let gem = getActiveGemType(gender);

  if (item && gem) {
    item.textContent = gem.getAttribute(INPUT_TEXT_ATTR);
  }
};

export default function(changedItem) {
  // eslint-disable-next-line no-undef
  let formData = new FormData(querySelectorId(FORM_ID));

  xhrLoad(
    window.location.pathname,
    function(data) {
      data = JSON.parse(data);

      setTotalPrice(data.price, getDefaultDeliveryId());
      setWithoutVatPrice(data['price-without-vat'], getDefaultDeliveryId());

      setWidth(GENDERS_ARRAY[0]);
      setWidth(GENDERS_ARRAY[1]);

      setWeight(GENDERS_ARRAY[0], data.mn_weight);
      setWeight(GENDERS_ARRAY[1], data.wm_weight);

      setColor(GENDERS_ARRAY[0]);
      setColor(GENDERS_ARRAY[1]);

      setThickness(GENDERS_ARRAY[0]);
      setThickness(GENDERS_ARRAY[1]);

      setSurface(GENDERS_ARRAY[0]);
      setSurface(GENDERS_ARRAY[1]);

      setGemType(GENDERS_ARRAY[0]);
      setGemType(GENDERS_ARRAY[1]);
    },
    null,
    'post',
    formatParams(formData)
  );

  setDescription(changedItem);
}
